import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import BlogCard from '../elements/BlogCard';
import AlertModal from '../modals/AlertModal';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css'
import FooterDiv from '../elements/FooterDiv';

interface BlogsPageState {
  category: string;
  blogs: any[];
  alert: string;
  navigate: string;
  loading: boolean;
  loadingMoreBlogs: boolean;
  noMoreBlogs: boolean;
}

class BlogsPage extends React.Component<{}, BlogsPageState> {

  constructor(props: any) {
    super(props);

    let category = sessionStorage.getItem('BlogsPageFilter');
    if (!category) category = 'community';

    this.state = {
      category: category,
      blogs: [],
      alert: '',
      navigate: '',
      loading: false,
      loadingMoreBlogs: false,
      noMoreBlogs: false
    }

    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onBlogClick = this.onBlogClick.bind(this);
    this.onBlogEdit = this.onBlogEdit.bind(this);
  }

  isAuthorCategory(cat:string) {
    return (cat != 'community' && cat != 'friends' && cat != 'following');
  }

  getProfilesInBlogs(blogs:any[]) {
    let profiles = [];
    for (let i = 0; i < blogs.length; i++) {
      if(profiles.indexOf(blogs[i].author) == -1)
        profiles.push(blogs[i].author);
    }
    return profiles;
  }

  componentDidMount() {
    this.loadBlogs();
  }

  addNewBlogsToExistingBlogs(newBlogs:any[], existingBlogs:any[]) {
    let blogs = [...existingBlogs];

    for (let newBlog of newBlogs) {
      let existingIndex = blogs.findIndex(blog => 
        blog.author === newBlog.author && blog.date === newBlog.date
      );
      
      if (existingIndex !== -1) 
        blogs[existingIndex] = newBlog;
      else
        blogs.push(newBlog);
    }

    this.sortBlogs(blogs);

    return blogs;
  }

  sortBlogs(blogs:any[]) {
    blogs.sort((a:any, b:any)=>{
      if(a.date > b.date)
        return -1;
      return 0;
    })
  }

  async loadBlogs() {
    let cachedBlogs = await Server.blogs.getBlogsCache(this.state.category);

    let updating = false;
    if(cachedBlogs) {
      let profiles = this.getProfilesInBlogs(cachedBlogs);
      profiles = profiles.filter((profile:any)=>Server.public.getProfile(profile) == null);
      if(profiles.length > 0) {
        this.setState({loading: true});
        await Server.public.loadProfiles(profiles);
      }

      this.setState({blogs: cachedBlogs, noMoreBlogs: cachedBlogs.length < 10});
      
      updating = cachedBlogs.length > 0;
      let blogRefreshTime = window.sessionStorage.getItem(`BlogRefresh#${this.state.category}`);
      if(blogRefreshTime) {
        let refreshTime = parseInt(blogRefreshTime);
        let now = new Date().getTime();
        if(now - refreshTime < 1000 * 60) {
          this.setState({loading: false});
          return;
        }
      }
    }

    if(!updating)
      this.setState({loading: true});

    let params:any = {limit: 10};

    if(updating)
      params.after = {date: cachedBlogs[0].date, id: cachedBlogs[0].id};

    if(this.isAuthorCategory(this.state.category)) {
      params.author = Server.user.getId();
      if(this.state.category != 'user')
        params.state = this.state.category;
    }
    else {
      params.state = 'published';
      if(this.state.category == 'friends' || this.state.category == 'following')
        params.filter = this.state.category;
    }

    let response = await Server.blogs.getBlogs(params);

    if(!response.success) {
      this.setState({loading: false, alert: response.message});
      return;
    }

    window.sessionStorage.setItem(`BlogRefresh#${this.state.category}`, new Date().getTime().toString());
    
    let newBlogs = response.blogs;

    if(newBlogs.length == 0 && updating) {
      this.setState({loading: false});
      return;
    }

    let profiles = this.getProfilesInBlogs(newBlogs);
    await Server.public.loadProfiles(profiles);

    // building new list of topics
    let blogs = [];
    if(updating && newBlogs.length < 10)
      blogs = [...cachedBlogs];
    
    blogs = this.addNewBlogsToExistingBlogs(newBlogs, blogs);

    await Server.blogs.setBlogsCache(this.state.category, blogs, updating);

    if(!updating) {
      let noMoreBlogs = blogs.length < 10;
      this.setState({noMoreBlogs});
    }

    this.setState({blogs, loading: false});
  }

  async loadMoreBlogs() {
    this.setState({loadingMoreBlogs: true});

    let params:any = {limit: 10};

    let blog = this.state.blogs[this.state.blogs.length-1];
    params.before = {date: blog.date, id: blog.id};

    let response = await Server.blogs.getBlogs(params);

    if(!response.success) {
      this.setState({loadingMoreBlogs: false, alert: response.message});
      return;
    }

    let newBlogs = response.blogs;

    if(newBlogs.length == 0) {
      this.setState({loadingMoreBlogs: false, noMoreBlogs: true});
      return;
    }

    let profiles = this.getProfilesInBlogs(newBlogs);
    await Server.public.loadProfiles(profiles);

    let blogs = this.addNewBlogsToExistingBlogs(newBlogs, this.state.blogs);

    await Server.blogs.setBlogsCache(this.state.category, blogs, true);

    let noMoreBlogs = blogs.length < 10;

    this.setState({blogs, noMoreBlogs, loadingMoreBlogs: false});
  }

  onCategoryChange(e: any) {
    sessionStorage.setItem('BlogsPageFilter', e.target.value);
    this.setState({category: e.target.value});

    let categoryLocked = !Server.isLoggedIn() && e.target.value != 'community';

    if(!categoryLocked) {
      setTimeout(() => {
        this.setState({blogs: []});
        this.loadBlogs();
      }, 10);
    }
  }

  onBlogClick(blog:any) {
    this.setState({navigate: '/blog/' + blog.slug})
  }

  onBlogEdit(blog:any) {
    this.setState({navigate: '/blog/edit/' + blog.slug})
  }

  onLoadMore() {
    this.loadMoreBlogs()
  }

  onNewBlog() {
    if(!Server.isLoggedIn()) {
      this.setState({alert: 'Please login to post blogs.'});
      return;
    }

    this.setState({navigate: '/blog/new'});
  }

  renderBlogs() {
    if(this.state.loading) 
      return (<div className="site-page-panel">Loading...</div>); 

    let blogs = this.state.blogs;

    let divs = [];
    for (let i = 0; i < blogs.length; i++)
      divs.push(<BlogCard key={i} data={blogs[i]} category={this.state.category} onClick={this.onBlogClick} onEdit={this.onBlogEdit}/>);

    return divs.length > 0 
      ? <div style={{display: 'flex', flexDirection: 'column', rowGap: '10px'}}>
          {divs}
          {!this.state.loading && !this.state.noMoreBlogs &&
            <div>
              <button
                onClick={()=>this.onLoadMore()}
                disabled={this.state.loadingMoreBlogs ? true : false}
              >
                {this.state.loadingMoreBlogs ? 'Loading...' : 'Load More'}
              </button>
            </div>
          }
        </div>
      : <div className="site-page-panel">There are no blogs in this category.</div>
  }

  render() {
    if(this.state.navigate)
      return (<Navigate to={this.state.navigate} state={{from:'blogs'}} />);      

    let categoryLocked = !Server.isLoggedIn() && this.state.category != 'community';

    let lockMessages = [];
    lockMessages['friends'] = 'Please login to view blogs from your friends.';
    lockMessages['following'] = 'Please login to view blogs from the people you follow.';
    lockMessages['user'] = 'Please login to view your own blogs.';
    lockMessages['published'] = 'Please login to view your published blogs.';
    lockMessages['draft'] = 'Please login to view your draft blogs.';
    lockMessages['archived'] = 'Please login to view your archived blogs.';
    
    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <div className="site-page-column">
            <div className="site-page-row" style={{justifyContent: 'space-between'}}>
              <select
                id="BlogsFilterSelect"
                style={{padding: '0 10px'}}
                value={this.state.category} 
                onChange={this.onCategoryChange}
                disabled={this.state.loading}
              >
                <option value="community">Community</option>
                <option value="friends">Friends</option>
                <option value="following">Following</option>
                <option value="user">My Blogs</option>
                <option value="published">My Published</option>
                <option value="draft">My Drafts</option>
                <option value="archived">My Archived</option>
              </select>
              
              <button onClick={()=>this.onNewBlog()} disabled={this.state.loading}>New Blog</button>
            </div>

            {categoryLocked ? 
              <div className="site-page-panel">{lockMessages[this.state.category]}</div> 
              : 
              this.renderBlogs()
            }
          </div>
        </PageEnvelope>
        
        <FooterDiv />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    )
  }
}

export default BlogsPage;